import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import {useAuth0} from '@auth0/auth0-react';

const {FiZap, FiLogIn} = FiIcons;

const AuthWrapper = ({children}) => {
  const {isAuthenticated, isLoading, loginWithRedirect, error} = useAuth0();

  // Debug logging
  React.useEffect(() => {
    console.log('Auth State:', {isAuthenticated, isLoading, error});
  }, [isAuthenticated, isLoading, error]);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 flex items-center justify-center">
        <motion.div
          initial={{opacity: 0, scale: 0.9}}
          animate={{opacity: 1, scale: 1}}
          className="text-center"
        >
          <div className="w-16 h-16 bg-gradient-to-r from-primary-500 to-primary-600 rounded-xl flex items-center justify-center shadow-lg mb-4 mx-auto">
            <SafeIcon icon={FiZap} className="w-8 h-8 text-white animate-pulse" />
          </div>
          <p className="text-gray-600">Loading FuelDash...</p>
        </motion.div>
      </div>
    );
  }

  if (isAuthenticated) {
    return children;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 flex items-center justify-center p-4">
      <motion.div
        initial={{opacity: 0, y: 20}}
        animate={{opacity: 1, y: 0}}
        className="w-full max-w-md"
      >
        {/* Logo */}
        <motion.div
          className="text-center mb-8"
          initial={{opacity: 0, scale: 0.8}}
          animate={{opacity: 1, scale: 1}}
          transition={{delay: 0.1}}
        >
          <div className="w-16 h-16 bg-gradient-to-r from-primary-500 to-primary-600 rounded-xl flex items-center justify-center shadow-lg mx-auto mb-4">
            <SafeIcon icon={FiZap} className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-3xl font-bold gradient-text">FuelDash</h1>
          <p className="text-gray-600 mt-2">Your business intelligence platform</p>
        </motion.div>

        {/* Login Card */}
        <motion.div
          initial={{opacity: 0, y: 10}}
          animate={{opacity: 1, y: 0}}
          transition={{delay: 0.2}}
          className="bg-white rounded-2xl shadow-xl border border-white/20 p-8"
        >
          <div className="text-center mb-6">
            <h2 className="text-2xl font-bold text-gray-900">Welcome Back</h2>
            <p className="text-gray-600 mt-1">Sign in to access your dashboard</p>
          </div>

          <button
            onClick={() => loginWithRedirect()}
            className="w-full py-3 px-4 bg-gradient-to-r from-primary-500 to-primary-600 text-white font-semibold rounded-lg hover:from-primary-600 hover:to-primary-700 focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 transition-all duration-200 flex items-center justify-center"
          >
            <SafeIcon icon={FiLogIn} className="w-5 h-5 mr-2" />
            Sign In with Auth0
          </button>

          <p className="text-xs text-gray-500 text-center mt-4">
            Secure authentication powered by Auth0
          </p>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default AuthWrapper;